import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Prompt } from "react-router-dom";
import ScrollIntoView from "../../../../shared/scroll-into-view/scroll-into-view";
import Loader from "./../../../../shared/loader";
import {
  fetchShotsOverview,
  updateShotOrder,
  saveShotsOrder,
  deleteMultipleShots
} from "./ducks/actions";
import { Overview } from "./overview";
import { formatTime } from "../../../../shared/format-time";

const OverviewContainer = (props) => {
  const filmId = props.match.params.filmId;
  const sceneId = props.match.params.sceneId;
  const {
    fetchShotsOverview,
    overview,
    loading,
    errors,
    warnings,
    saving,
    updateShotOrder,
    saveShotsOrder,
    pristine,
    shotsOnboardingSteps,
    filmName,
    isUploading,
    deleteMultipleShots,
    deleteing
  } = props;

  useEffect(() => {
    fetchShotsOverview(filmId, sceneId);
  }, [filmId, sceneId, fetchShotsOverview]);

  const onSaveShotsOrder = (shots) => {
    saveShotsOrder(filmId, sceneId, shots);
  }

  const csvData = (overview?.shots || []).map((shot: any) => {
    return [shot.number, shot.shotSizeDescription, shot.lensFocalLength, shot.movementDescriptions, shot.characters, shot.backgroundCharacters, shot.frameRate, formatTime(shot.estimatedSetupDuration), formatTime(shot.estimatedShootingDuration), formatTime(shot.estimatedTotalShootingDuration), shot.description, shot.notes];
  });

  csvData?.unshift(["Shot", "Size", "Focal Length", "Movements", "Characters", "Background Characters", "Frame Rate", "Setup Duration", "Shooting Duration", "Total Shooting Duration", "Description", "Notes"]);

  function renderOverview(overview) {

    return (
      <ScrollIntoView
        className="blade-content wider"
        path="/films/:filmId/shots/overview"
        loading={loading}>
        <Prompt when={!pristine} message="" />
        <h2 className="menu-label">Overview</h2>
        <Overview
          overview={overview}
          filmId={filmId}
          sceneId={sceneId}
          errors={errors}
          warnings={warnings}
          pristine={pristine}
          updateShotOrder={updateShotOrder}
          saveShotsOrder={onSaveShotsOrder}
          saving={saving}
          shotsOnboardingSteps={shotsOnboardingSteps}
          csvData={csvData}
          sceneNumber={overview.sceneNumber}
          filmName={filmName}
          isUploading={isUploading}
          deleteMultipleShots={deleteMultipleShots}
          deleteing={deleteing} />
      </ScrollIntoView>
    );
  }

  return (
    <>
      {(loading || !overview || saving) && <Loader />}
      {!loading && overview && renderOverview(overview)}
    </>
  );
};

function mapStateToProps(state) {
  const { errors, warnings, overview, loading, saving, pristine, shotsOnboardingSteps, isUploading, deleteing } =
    state.shotsOverviewState;
  return {
    errors,
    warnings,
    overview,
    loading,
    saving,
    pristine,
    shotsOnboardingSteps,
    isUploading,
    filmName: state.filmsState?.userFilm?.name,
    deleteing
  };
}

export default connect(mapStateToProps, {
  fetchShotsOverview,
  updateShotOrder,
  saveShotsOrder,
  deleteMultipleShots
})(OverviewContainer);
